export default "__VITE_PUBLIC_ASSET__737a7f48__"